import React, { useEffect, useState } from 'react'
import PageTitle from '../../../jsx/layouts/PageTitle';
import ReactPaginate from 'react-paginate';
import { Form } from 'react-bootstrap';
import { getVenueList, fetchAllClusters } from '../../../services/adminApiService/venueManagerApi/venueManagerApi';
import FilterNumber from '../../../jsx/components/FilterNumberDropDown/FilterNumber';
import SearchFilter from '../../../jsx/components/SearchFilter/SearchFilter';
import useSearchValue from '../../../hooks/useSearchValue';

const VenuesList = () => {
    const [venues, setVenues] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const { searchValue, setSearchValue, debouncedSearchValue } = useSearchValue();
    const [clusters, setClusters] = useState([]);
    const [selectedClusterId, setSelectedClusterId] = useState('');

    useEffect(() => {
        const getClusters = async () => {
            try {
                const res = await fetchAllClusters();
                setClusters(res?.data?.data || []);
            } catch (error) {
                console.error('Error fetching clusters:', error);
            }
        };
        getClusters();
    }, []);

    useEffect(() => {
        const fetchVenues = async () => {
            setLoading(true);
            try {
                const response = await getVenueList({
                    page: currentPage,
                    limit: perPage,
                    cluster_id: selectedClusterId || undefined,
                    search: debouncedSearchValue || undefined,
                });
                setVenues(response?.data?.data || []);
                setTotalPages(response?.data?.totalPages || 1);
            } catch (error) {
                console.error('Venues list error:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchVenues();
    }, [currentPage, perPage, selectedClusterId, debouncedSearchValue]);

    return (
        <>
            <PageTitle activeMenu="All Venues" motherMenu="Dashboard" />
            <div className="col-12">
                <div className="card filter-card-wrapper">
                    <div className="px-3 d-flex justify-content-between">
                        <div className="d-flex mt-3 mx-2">
                            <div>
                                <FilterNumber value={perPage} onChange={(val) => {
                                    setPerPage(val);
                                    setCurrentPage(1);
                                }} />
                            </div>
                            <div>
                                <SearchFilter searchValue={searchValue} setSearchValue={setSearchValue} setCurrentPage={setCurrentPage} />
                            </div>
                        </div>
                    </div>
                    <div className="mx-4 d-flex mt-2">
                        <div>
                            <Form.Select
                                value={selectedClusterId}
                                onChange={(e) => {
                                    setSelectedClusterId(e.target.value);
                                    setCurrentPage(1);
                                }}
                                className="me-2"
                                style={{ width: '100%', padding: '11px 50px 10px 11px' }}
                            >
                                <option value="">All Clusters</option>
                                {clusters.map((cluster) => (
                                    <option key={cluster.id} value={cluster.id}>{cluster.cluster_name}</option>
                                ))}
                            </Form.Select>
                        </div>
                    </div>

                    <div className="card-body">
                        {loading ? (
                            <div className="text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <div className="w-100 table-responsive">
                                <table id="example" className="display w-100 dataTable">
                                    <thead>
                                        <tr>
                                            <th>SN</th>
                                            <th>Venue Name</th>
                                            <th>Cluster</th>
                                            <th>Assigned</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {venues.length > 0 ? (
                                            venues.map((data, index) => {
                                                const serialNumber = (currentPage - 1) * perPage + (index + 1);
                                                return (
                                                    <tr key={data.id}>
                                                        <td>{serialNumber}</td>
                                                        <td>{data?.venue_name}</td>
                                                        <td>{data?.parent_cluster?.cluster_name || '-'}</td>
                                                        <td>{data?.cluster_id ? 'Yes' : 'No'}</td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="4" className="text-center">Data is not available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
                <ReactPaginate
                    nextLabel="next >"
                    onPageChange={(e) => setCurrentPage(e.selected + 1)}
                    pageRangeDisplayed={8}
                    marginPagesDisplayed={7}
                    pageCount={totalPages}
                    previousLabel="< previous"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination d-flex flex-wrap"
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                />
            </div>
        </>
    )
}

export default VenuesList
